
import { Mixins, Component } from 'vue-property-decorator';
import FeatureFlagMixin from '@/features/common/mixins/featureFlagMixin';

@Component
export default class SettingsList extends Mixins(FeatureFlagMixin) {
  protected featureKeysToLoad = ['updatesPreferences'];

  private get settingsList() {
    const list = [
      {
        displayLabel: this.$t('preferences.shippingSettings') as string,
        queryContent: 'shippingSettings',
        icon: 'mdi-package-variant-closed',
      },
      {
        displayLabel: this.$t('preferences.customsSettings') as string,
        queryContent: 'customs',
        icon: 'mdi-account-tie',
      },
      {
        displayLabel: this.$t('preferences.printSettings') as string,
        queryContent: 'printSettings',
        icon: 'mdi-printer',
      },
      {
        displayLabel: this.$t('preferences.schedulePickup') as string,
        queryContent: 'schedulePickup',
        icon: 'mdi-calendar-month',
      },
      {
        displayLabel: this.$t('preferences.ecommerce') as string,
        queryContent: 'ecommerce',
        icon: 'mdi-cart',
      },
      {
        displayLabel: this.$t('preferences.carrierFilters') as string,
        queryContent: 'carrierFilters',
        icon: 'mdi-truck',
      },
    ];

    if (this.featureFlags.updatesPreferences) {
      list.push({
        displayLabel: this.$t('preferences.updatesPreferences') as string,
        queryContent: 'updatesPreferences',
        icon: 'mdi-email',
      });
    }

    return list;
  }
}
